import { Box,Typography } from '@mui/material';
import React from 'react';

const Scooreboard = ()=>{
    return(
        <Box
            sx={{
                backgroundColor: "yellow",
            }}
        >
            <Typography>
                Scooreboard
            </Typography>
        </Box>
    )
}
export default Scooreboard;